/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Inbox_FromInputs */

const en_inbox_from = /** @type {(inputs: Inbox_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.from}`)
};

const de_inbox_from = /** @type {(inputs: Inbox_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.from}`)
};

/**
* | output |
* | --- |
* | "From {from}" |
*
* @param {Inbox_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_from = /** @type {((inputs: Inbox_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_from(inputs)
	return en_inbox_from(inputs)
});